import { ESkuCharacteristicType } from '@/types/Catalog/ESkuCharacteristicType'
import type { ISkuCharacteristicMultiSelectValue } from '@/types/Catalog/ISkuCharacteristicMultiSelectValue'
import type { ISkuCharacteristicNumberValue } from '@/types/Catalog/ISkuCharacteristicNumberValue'
import type { ISkuCharacteristicSelectValue } from '@/types/Catalog/ISkuCharacteristicSelectValue'
import type { ISkuCharacteristicTextValue } from '@/types/Catalog/ISkuCharacteristicTextValue'
import type { TSkuCharacteristicValue } from '@/types/Catalog/TSkuCharacteristicValue'

export const isTextCharacteristicValue = (value: TSkuCharacteristicValue): value is ISkuCharacteristicTextValue => {
  return value.type === ESkuCharacteristicType.TEXT
}

export const isSelectCharacteristicValue = (value: TSkuCharacteristicValue): value is ISkuCharacteristicSelectValue => {
  return value.type === ESkuCharacteristicType.SINGLE_SELECT
}

export const isMultiSelectCharacteristicValue = (value: TSkuCharacteristicValue): value is ISkuCharacteristicMultiSelectValue => {
  return value.type === ESkuCharacteristicType.MULTI_SELECT
}

export const isNumberCharacteristicValue = (value: TSkuCharacteristicValue): value is ISkuCharacteristicNumberValue => {
  return value.type === ESkuCharacteristicType.NUMBER
}
